import { ReleaseState } from './state';
import { newRelease } from './new-release';

export const releaseInitialState: ReleaseState = {
  list: {},
  listArtist: [],
  listDeactivatedArtist: { id: '', releases: [] },
  featuring: [],
  summary: {},
  artistMap: {},
  activeSection: 'all',
  release: newRelease(),
  missingSpotifyArtists: [],
  allReleaseArtists: [],
  updateStatus: 'initial',
  locked: false,
  validationErrors: [],
};
